import axios from 'axios'
import {
	clearIncompatibleSignstoreAuthForThirdPart,
	clearSignstoreH5AuthSession,
	clearSignstoreH5UserInfo,
	isSignstoreStaleUserError,
	isSignstoreUnauthorizedResponse
} from '../../../utils/signstore-h5-auth.js'
import {
	SIGNSTORE_APP_BASE,
	SIGNSTORE_AUTH_KIND_KEY,
	SIGNSTORE_AUTH_SUB_KEY,
	SIGNSTORE_USER_INFO_KEY
} from './config.js'
import { syncCarActivitySession } from './signstore-api.js'
import { cvQuery, getCarvueRoot } from '../utils/dom.js'

let routeQuery = {}

export function setCarvueRouteQuery(query) {
	routeQuery = query && typeof query === 'object' ? { ...query } : {}
}

/** 合并 hash / search / 路由 query，避免 #/carvue?uid= 未被 vue-router 解析时丢参 */
export function parseCarvueQueryFromLocation(routeQueryFromRouter) {
	const merged = {}
	const applyParams = function (params) {
		params.forEach(function (value, key) {
			if (value != null && String(value).trim() !== '') {
				merged[key] = String(value).trim()
			}
		})
	}
	if (routeQueryFromRouter && typeof routeQueryFromRouter === 'object') {
		Object.keys(routeQueryFromRouter).forEach(function (k) {
			const v = routeQueryFromRouter[k]
			if (v != null && String(v).trim() !== '') {
				merged[k] = String(v).trim()
			}
		})
	}
	const search = typeof window !== 'undefined' ? window.location.search : ''
	if (search && search.length > 1) {
		applyParams(new URLSearchParams(search))
	}
	const hash = typeof window !== 'undefined' ? window.location.hash || '' : ''
	const qi = hash.indexOf('?')
	if (qi >= 0) {
		applyParams(new URLSearchParams(hash.slice(qi + 1)))
	}
	if (!merged.activity_code && !merged.activityCode && merged.scene) {
		try {
			merged.activity_code = decodeURIComponent(String(merged.scene))
		} catch (e) {
			merged.activity_code = String(merged.scene)
		}
	}
	return merged
}

/** 支持 #/carvue?uid= 与 /carvue?uid= */
export function getCarQueryParams() {
	const keys = Object.keys(routeQuery)
	const p = new URLSearchParams()
	if (keys.length) {
		keys.forEach(function (k) {
			if (routeQuery[k] != null && String(routeQuery[k]).trim() !== '') {
				p.set(k, String(routeQuery[k]).trim())
			}
		})
	}
	const hash = typeof window !== 'undefined' ? window.location.hash || '' : ''
	const qi = hash.indexOf('?')
	if (qi >= 0) {
		new URLSearchParams(hash.slice(qi + 1)).forEach(function (value, key) {
			if (!p.has(key) && value != null && String(value).trim() !== '') {
				p.set(key, String(value).trim())
			}
		})
	}
	if (p.toString()) return p
	const search = typeof window !== 'undefined' ? window.location.search : ''
	if (search && search.length > 1) {
		return new URLSearchParams(search)
	}
	return p
}

export function getUrlUid() {
	const raw = getCarQueryParams().get('uid')
	return raw != null ? String(raw).trim() : ''
}

export function getUrlActivityCode() {
	const q = getCarQueryParams()
	const raw = q.get('activity_code') || q.get('activityCode')
	return raw != null ? String(raw).trim() : ''
}

function getStoredToken() {
	try {
		const t = window.localStorage.getItem('token')
		const s = t != null ? String(t).trim() : ''
		return s && s !== 'null' && s !== 'undefined' ? s : ''
	} catch (e) {
		return ''
	}
}

function canReuseThirdPartToken(uid) {
	if (!uid || !getStoredToken()) return false
	try {
		const kind = String(window.localStorage.getItem(SIGNSTORE_AUTH_KIND_KEY) || '').trim()
		const sub = String(window.localStorage.getItem(SIGNSTORE_AUTH_SUB_KEY) || '').trim()
		return kind === 'thirdPart' && sub === uid
	} catch (e) {
		return false
	}
}

function persistThirdPartLogin(loginData, uid) {
	const token = loginData && loginData.token
	if (!token) throw new Error('登录失败')
	try {
		window.localStorage.setItem('token', token)
		if (loginData.userInfo) {
			window.localStorage.setItem(SIGNSTORE_USER_INFO_KEY, JSON.stringify(loginData.userInfo))
		}
		window.localStorage.setItem(SIGNSTORE_AUTH_KIND_KEY, 'thirdPart')
		window.localStorage.setItem(SIGNSTORE_AUTH_SUB_KEY, uid)
	} catch (e) {
		console.warn('写入登录缓存失败', e)
	}
	const openid =
		loginData.userInfo && loginData.userInfo.openid != null
			? String(loginData.userInfo.openid).trim()
			: ''
	window.__carvueSessionOpenId = openid || uid
}

function isUnauthorizedResponse(res) {
	if (!res || typeof res !== 'object') return false
	if (Number(res.status) === 401) return true
	const msg = res.msg != null ? String(res.msg) : ''
	return /非法访问|未授权|未登录/i.test(msg)
}

export function blockPage(message) {
	const pag = cvQuery('.swiper-pagaBox')
	if (pag) pag.style.display = 'none'
	const homeCheck = cvQuery('#homeCheck')
	if (homeCheck) {
		homeCheck.hidden = true
		homeCheck.classList.remove('is-show')
	}
	// 不能隐藏 .fullscreen：#loading 在其内部，父级 display:none 会导致手机端纯黑屏
	const main = cvQuery('.fullscreen')
	if (main) main.style.display = ''

	const root = getCarvueRoot() || cvQuery('.carvue-root')
	const loading = cvQuery('#loading')
	if (loading) {
		if (root && loading.parentElement !== root) {
			root.appendChild(loading)
		}
		loading.style.position = 'fixed'
		loading.style.inset = '0'
		loading.style.zIndex = '10000'
		loading.style.opacity = '1'
		loading.style.pointerEvents = 'auto'
		loading.style.display = 'flex'
		const bars = loading.querySelector('.loader-bars')
		if (bars) bars.style.display = 'none'
		const text = loading.querySelector('.loading-text')
		if (text) {
			text.hidden = false
			text.textContent = message || '无法访问'
		}
	} else {
		const root = cvQuery('.carvue-root') || document.body
		const box = document.createElement('div')
		box.className = 'carvue-block-msg'
		box.textContent = message || '无法访问'
		box.setAttribute(
			'style',
			'display:flex;align-items:center;justify-content:center;height:100%;color:#fff;background:#000;padding:24px;text-align:center;font-size:16px;'
		)
		if (root) {
			root.innerHTML = ''
			root.appendChild(box)
		}
	}
}

async function runThirdPartSilentLogin(uid, activityCode) {
	const res = await axios({
		method: 'post',
		url: SIGNSTORE_APP_BASE + '/wxapp/h5ThirdPartSilent',
		headers: { 'Content-Type': 'application/json' },
		data: { uid, activityCode },
		timeout: 15000
	})
	const body = res.data
	if (isUnauthorizedResponse(body)) {
		throw new Error((body && body.msg) || '非法访问')
	}
	if (!body || Number(body.status) !== 200 || !body.data || !body.data.token) {
		throw new Error((body && body.msg) || '登录失败')
	}
	persistThirdPartLogin(body.data, uid)
}

function restoreThirdPartOpenIdFromCache() {
	try {
		const raw = window.localStorage.getItem(SIGNSTORE_USER_INFO_KEY)
		const userInfo = raw ? JSON.parse(raw) : null
		if (userInfo && userInfo.openid) {
			window.__carvueSessionOpenId = String(userInfo.openid).trim()
		}
	} catch (e) {
		// ignore
	}
}

function isAuthUnauthorizedError(e) {
	const body = e && e.response && e.response.data
	if (isSignstoreUnauthorizedResponse(body)) return true
	const msg = e && e.message != null ? String(e.message) : ''
	return /非法访问|未授权|未登录/i.test(msg)
}

/** 静默登录 + 拉活动；forceLogin 为 true 时跳过 token 复用 */
async function loginAndSyncActivity(uid, activityCode, forceLogin, staleUserRetried) {
	if (forceLogin || !canReuseThirdPartToken(uid)) {
		await runThirdPartSilentLogin(uid, activityCode)
	} else {
		restoreThirdPartOpenIdFromCache()
	}
	try {
		await syncCarActivitySession(activityCode)
	} catch (e) {
		if (!staleUserRetried && isSignstoreStaleUserError(e)) {
			clearSignstoreH5AuthSession()
			clearSignstoreH5UserInfo()
			window.__carActivityUserId = null
			window.__carActivityDetail = null
			return loginAndSyncActivity(uid, activityCode, true, true)
		}
		throw e
	}
}

export async function ensureCarPageAuth() {
	const uid = getUrlUid()
	const activityCode = getUrlActivityCode()

	if (!uid) {
		blockPage('请通过活动入口访问（缺少 uid）')
		return false
	}
	if (!activityCode) {
		blockPage('活动编码不存在')
		return false
	}

	window.__carvueSessionOpenId = uid
	// 清掉匿名/其他 uid 的 token，避免带着旧 token 调 signstore 报「非法访问」
	clearIncompatibleSignstoreAuthForThirdPart(uid)

	try {
		await loginAndSyncActivity(uid, activityCode, false)
		return true
	} catch (e) {
		if (!isAuthUnauthorizedError(e)) {
			const msg =
				(e.response && e.response.data && e.response.data.msg) ||
				e.message ||
				'登录失败'
			blockPage(msg)
			return false
		}
		// 对齐 activity-multi：token 过期/不匹配时清缓存后强制重登一次
		try {
			clearSignstoreH5AuthSession()
			await loginAndSyncActivity(uid, activityCode, true)
			return true
		} catch (e2) {
			const msg =
				(e2.response && e2.response.data && e2.response.data.msg) ||
				e2.message ||
				'登录失败'
			blockPage(msg)
			return false
		}
	}
}

export function getCarOpenId() {
	if (typeof window.__carvueSessionOpenId === 'string' && window.__carvueSessionOpenId) {
		return window.__carvueSessionOpenId
	}
	return getUrlUid()
}

export function getCarAuthToken() {
	return getStoredToken()
}
